import {
    REQUEST as req,
    RESPONSE as res,
    FAILURE as fail,
    CLEAR as clr,
  } from '../../actions/deployments/list';
  import { SILENT_REQUEST } from '../../sagas/deployments/list';
  
  const initialState = {
    response: {
      deployments: [],
      total: 0,
      page: 1,
      pages: 1,
      showing: 0
    },
    isLoading: false,
    error: null,
    lastSilentUpdate: null
  };
  
  export const reducer = (state = initialState, action) => {
    switch (action.type) {
      case req:
        return {
          ...state,
          isLoading: true,
          error: null
        };
      case 'DEPLOYMENTS_LIST_LOADING':
        return {
          ...state,
          isLoading: action.payload
        };
      case res:
        return {
          ...state,
          isLoading: false,
          response: action.payload
        };
      case 'DEPLOYMENTS_LIST_SILENTLY_UPDATED':
        return {
          ...state,
          lastSilentUpdate: action.timestamp
        };
      case SILENT_REQUEST:
        // Don't change loading state for silent requests
        return state;
      case fail:
        return {
          ...state,
          isLoading: false,
          error: action.payload
        };
      case clr:
        return {
          ...state,
          response: {
            deployments: [],
            total: 0,
            page: 1,
            pages: 1,
            showing: 0
          },
          isLoading: false,
          error: null
        };
      default:
        return state;
    }
  };
